// src/components/CompleteInfo.js

import React, { useState, useEffect, useCallback } from 'react';
import { auth, db } from '../firebase'; // Corretto il percorso dell'import
import { updateProfile } from 'firebase/auth';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';

const CompleteInfo = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [role, setRole] = useState('');
    const [institution, setInstitution] = useState('');
    const [isAuthLoading, setIsAuthLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const checkUserInfo = async () => {
            try {
                const user = auth.currentUser;
                if (user) {
                    const userDocRef = doc(db, 'users', user.uid);
                    const userDocSnap = await getDoc(userDocRef);
                    if (userDocSnap.exists()) {
                        const data = userDocSnap.data();
                        const infoComplete = data.firstName?.trim() !== '' && data.lastName?.trim() !== '' && data.role?.trim() !== '';
                        if (infoComplete) {
                            // Se le informazioni sono complete, reindirizza alla dashboard
                            navigate('/dashboard');
                        }
                        // Altrimenti, rimani su questa pagina per completare le informazioni
                    } else {
                        // Se il documento non esiste, rimani su questa pagina
                    }
                } else {
                    // Se l'utente non è autenticato, reindirizza al login
                    navigate('/');
                }
            } catch (err) {
                console.error('Error:', err);
                setError('Error. Please try again.');
            } finally {
                setIsAuthLoading(false);
            }
        };
        checkUserInfo();
    }, [navigate]);

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        setError(null);
        setIsSubmitting(true);
        try {
            const user = auth.currentUser;
            if (user) {
                // Salva le informazioni su Firestore
                const userDocRef = doc(db, 'users', user.uid);
                await setDoc(userDocRef, {
                    firstName: firstName.trim(),
                    lastName: lastName.trim(),
                    role,
                    institution: (role === 'student' || role === 'institution') ? institution.trim() : '',
                    email: user.email,
                }, { merge: true });

                // Aggiorna il profilo utente
                await updateProfile(user, {
                    displayName: `${firstName.trim()} ${lastName.trim()}`,
                });

                // Reindirizza alla dashboard
                navigate('/dashboard');
            } else {
                setError('Please log in.');
                navigate('/');
            }
        } catch (err) {
            console.error('Error:', err);
            setError('Save error, please try again.');
        } finally {
            setIsSubmitting(false);
        }
    }, [firstName, lastName, role, institution, navigate]);

    if (isAuthLoading) {
        return (
            <div className="loading-overlay">
                <div className="loading-content">
                    <Circles height="80" width="80" color="#ffffff" ariaLabel="loading" />
                    <p>Loading... Syncing profile info</p>
                </div>
            </div>
        );
    }

    return (
        <div className="complete-info-container">
            <h2>Complete Your Information</h2>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit} className="complete-info-form">
                <div className="form-group">
                    <label htmlFor="firstName">First Name</label>
                    <input
                        type="text"
                        id="firstName"
                        placeholder="First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                        disabled={isSubmitting}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="lastName">Last Name</label>
                    <input
                        type="text"
                        id="lastName"
                        placeholder="Last Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                        disabled={isSubmitting}
                    />
                </div>
                <div className="form-group">
                    <p><label htmlFor="role">Role</label></p>

                    <select
                        id="role"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        required
                        disabled={isSubmitting}
                    >
                        <option value="">Select Your Role</option>
                        <option value="student">Student</option>
                        <option value="institution">Institution</option>
                        <option value="personal">Personal use</option>
                    </select>
                </div>
                {(role === 'student' || role === 'institution') && (
                    <div className="form-group">
                        <label htmlFor="institution">Institution/University/School</label>
                        <input
                            type="text"
                            id="institution"
                            placeholder="Institution/University/School"
                            value={institution}
                            onChange={(e) => setInstitution(e.target.value)}
                            required
                            disabled={isSubmitting}
                        />
                    </div>
                )}
                <div className="terms-message">
                    <p>
                        By continuing, you accept the{' '}
                        <a href="https://ageestimation.netlify.app/privacy" target="_blank" rel="noopener noreferrer">
                            Terms and Conditions of Use
                        </a>{' '}
                        described in the Privacy Policy.
                    </p>
                </div>
                <button type="submit" className="submit-button" disabled={isSubmitting}>
                    {isSubmitting ? 'Saving...' : 'Save'}
                </button>
            </form>
        </div>
    );
};

export default CompleteInfo;